// user.js
export default {
  namespaced: true, // 使用namespaced确保模块的state、mutations、actions和getters是命名空间化的

  state() {
    return {
      token: null, // 用户token
      userInfo: null, // 用户信息
      // 其他用户相关状态...
    };
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      window.localStorage.setItem('userToken', token)
      // console.log(state.token);

    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
      // console.log(state.userInfo);

    },
    // 其他mutations...
  },

  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo);
    },
    // 其他actions...
  },

  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    // 其他getters...
  },
};